import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import { BLOCK_CONTROL_UI_CONTEXT } from '@atlaskit/editor-common/block-controls/block-control-ui-context';
import { BLOCK_CONTROLS_LEFT_GROUP } from '@atlaskit/editor-common/block-controls/surface-keys';
import type { RegisterButton } from '@atlaskit/editor-ui-control-model/types';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';

const messages = defineMessages({
	collapseSection: {
		id: 'editor-plugin-block-collapse.block-collapse-button-registration.collapseSection',
		defaultMessage: 'Collapse section',
		description: 'Accessible label for the button that collapses a heading section.',
	},
});

const ChevronDownSmallIcon = () => <ChevronDownIcon label="" size="small" />;

const BlockCollapseButton = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			appearance="subtle"
			icon={ChevronDownSmallIcon}
			label={formatMessage(messages.collapseSection)}
			spacing="compact"
			testId="editor-collapse-heading-button"
		/>
	);
};

export const getBlockCollapseButtonComponents = (): RegisterButton[] => [
	{
		key: 'block-controls-collapse-heading',
		type: 'button',
		parents: [{ ...BLOCK_CONTROLS_LEFT_GROUP, rank: 300 }],
		isHidden: ({ surfaceContext } = {}) => {
			const context = surfaceContext?.get(BLOCK_CONTROL_UI_CONTEXT);
			return (
				!context?.activeNode ||
				context.targetNode.pos !== context.activeNode.pos ||
				context.targetNode.type.name !== 'heading' ||
				context.targetNode.parentType !== 'doc'
			);
		},
		component: () => <BlockCollapseButton />,
	},
];
